module.exports = __webpack_public_path__ + "static/media/warrior-card.ee2acd63.png";